import { userConstants } from "../../constant";

const initialState = {
  questions: [],
};

export function productQuestions(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_PRODUCT_QUESTIONS:
      return {
        ...state,
        questions: action.payload,
      };
    default:
      return state;
  }
}
